import { BodyScanGender } from 'fitbeat.models';

export class UserInfoForBodyScan {
    public age: number;
    public height: number;
    public genderNumber: BodyScanGender;
}
